module.exports = __webpack_public_path__ + "img/guge.f0ebe659.png";